import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("C:/temporary/iqa/iQA_FRONT/layouts/dashboard.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("C:/temporary/iqa/iQA_FRONT/layouts/login.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("C:/temporary/iqa/iQA_FRONT/layouts/main.vue").then(m => m.default || m)),
  portal: defineAsyncComponent(() => import("C:/temporary/iqa/iQA_FRONT/layouts/portal.vue").then(m => m.default || m))
}